const { Mixin } = require('hops-mixin');
const urlJoin = require('url-join');
const { trackFetchTiming } = require('./logjam');

class HopsLogjamBrowserMixin extends Mixin {
  bootstrap() {
    const {
      logjam: { frontendBaseUrl, frontendHost },
    } = this.config;

    this.trackFetchTiming = this.trackFetchTiming.bind(this);

    this.frontendBaseUrl = frontendBaseUrl || frontendHost || '/';
  }

  allowedToLog() {
    const { location } = window.document;

    return (
      process.env.NODE_ENV === 'production' &&
      typeof location !== 'undefined' &&
      typeof location.hostname !== 'undefined' &&
      !location.hostname.startsWith('admin')
    );
  }

  trackFetchTiming(response, startTime, endTime) {
    if (!this.allowedToLog()) {
      return;
    }

    trackFetchTiming(
      urlJoin(this.frontendBaseUrl, '/logjam/ajax'),
      response,
      startTime,
      endTime
    );
  }

  configureFetch(fetch) {
    if (!this.allowedToLog()) {
      return fetch;
    }

    return (...fetchArgs) => {
      const startTime = Date.now();

      return fetch(...fetchArgs).then((response) => {
        const endTime = Date.now();

        this.trackFetchTiming(response, startTime, endTime);

        return response;
      });
    };
  }
}

module.exports = HopsLogjamBrowserMixin;
